<template>
  <b-card body-bg-variant="light"
          header="Experiment discipline"
          header-bg-variant="dark"
          header-text-variant="light">
    <label for="discipline">Discipline</label>
    <b-form-select id="discipline"
                   v-model="data.general.discipline"
                   :class="{ 'custom-invalid-input-border': $data.$v.data.general.discipline.$error }"
                   :disabled="!editable"
                   @input="$data.$v.data.general.discipline.$touch()"
                   @input.native="resetDisciplineSpecific()">
      <option v-for="option in Object.keys(disciplinesProp)" :key="option"
              :value="option">{{ option }}
      </option>
    </b-form-select>

    <div v-if="data.general.discipline === 'Others'">
      <label for="specificDisciplineOthers">Specific discipline</label>
      <b-form-input id="specificDisciplineOthers"
                    v-model="data.general.discipline_specific"
                    :class="{ 'custom-invalid-input-border': $data.$v.data.general.discipline_specific.$error }"
                    :readonly="!editable"
                    placeholder="Enter missing value"
                    type="text"
                    @input="$data.$v.data.general.discipline_specific.$touch()"></b-form-input>
    </div>

    <div v-if="isSpecificDisciplineEmpty">
      <label for="specificDisciplineEmpty">Specific discipline</label>
      <b-form-select id="specificDisciplineEmpty"
                     v-model="data.general.discipline_specific"
                     :class="{ 'custom-invalid-input-border': $data.$v.data.general.discipline_specific.$error }"
                     :disabled="!editable"
                     @input="$data.$v.data.general.discipline_specific.$touch()">
        <option v-for="option in disciplinesProp[data.general.discipline]" :key="option"
                :value="option">{{ option }}
        </option>
      </b-form-select>
    </div>

  </b-card>
</template>

<script>

  export default {
    name: 'ExperimentDiscipline',
    props: {
      value: undefined,
      editable: {
        type: Boolean,
        default: true,
      },
      disciplinesProp: undefined,
      validation: undefined,
    },
    computed: {
      isSpecificDisciplineEmpty() {
        if (this.hasProperty(this.data.general, 'discipline')) {
          return (
            this.data.general.discipline !== 'Other' && this.disciplinesProp[this.data.general.discipline].length > 0
          );
        }
        return false;
      },
    },
    data() {
      return {
        data: this.value,
        $v: this.validation,
      };
    },
    methods: {
      resetDisciplineSpecific() {
        if (this.data.general.discipline_specific !== undefined) {
          delete this.data.general.discipline_specific;
        }
      },
    },
    watch: {
      value: {
        handler() {
          this.data = this.value;
          if (this.data.general === undefined) {
            this.data.general = {};
          }
        },
        deep: true,
      },
    },
  };
</script>
